import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { FSAppsService } from "app/_services/fsapps.service";
import { UtilService } from '../../_services/util.service';

@Component({
    selector: 'app-admin-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.scss'],
    standalone: false
})
export class AdminLoginComponent {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fsAppsService: FSAppsService,
    public util: UtilService
  ) {
    this.login()
  }

  login(): any {
    const requestingUrl = window.location.pathname;
    localStorage.setItem('requestingUrl', '/admin/permits');
    this.fsAppsService.login().subscribe((result: any) => {
        this.util.navigateExternal(result.url);
    });
  }
}
